// ---------------------------------------------- modules import
import React, { FunctionComponent } from "react";
import { BrowserRouter, Route } from "react-router-dom";

import Login from "./components/auth/login";
import Dashboard from "./components/dashboard/dashboard";
import PinnedPost from "./components/dashboard/pinnedPost";
import Navbar from "./components/layout/navbar";
import Album from "./components/modules/album/album";
import Post from "./components/modules/post/post";
import User from "./components/modules/user/user";
import UserSettings from "./components/modules/userSettings/userSettings";
import ThemeContextProvider from "./contexts/themeContext";

import PermissionHelper, { MenuIndex } from "./store/helpers/permissionHelper";

// ---------------------------------------------- the component
const App: FunctionComponent = () => (
  <ThemeContextProvider>
    <BrowserRouter>
      <div>
        <Navbar />

        <Route exact path="/" component={Dashboard} />

        <Route path="/login" component={Login} />

        <Route path="/dashboard" component={PinnedPost} />

        <Route
          path="/user-settings"
          render={props => (
            <UserSettings {...props} menuIndex={MenuIndex.User}></UserSettings>
          )}
        />

        <Route
          path={`/${PermissionHelper.getUrl(MenuIndex.BodPost)}`}
          render={props => (
            <Post {...props} menuIndex={MenuIndex.BodPost}></Post>
          )}
        />

        <Route
          path={`/${PermissionHelper.getUrl(MenuIndex.CommonPost)}`}
          render={props => (
            <Post {...props} menuIndex={MenuIndex.CommonPost}></Post>
          )}
        />

        <Route
          path={`/${PermissionHelper.getUrl(MenuIndex.ExclusivePost)}`}
          render={props => (
            <Post {...props} menuIndex={MenuIndex.ExclusivePost}></Post>
          )}
        />

        <Route
          path={`/${PermissionHelper.getUrl(MenuIndex.FadPost)}`}
          render={props => (
            <Post {...props} menuIndex={MenuIndex.FadPost}></Post>
          )}
        />

        <Route
          path={`/${PermissionHelper.getUrl(MenuIndex.FssPost)}`}
          render={props => (
            <Post {...props} menuIndex={MenuIndex.FssPost}></Post>
          )}
        />

        <Route
          path={`/${PermissionHelper.getUrl(MenuIndex.GeneralPost)}`}
          render={props => (
            <Post {...props} menuIndex={MenuIndex.GeneralPost}></Post>
          )}
        />

        <Route
          path={`/${PermissionHelper.getUrl(MenuIndex.HrgaPost)}`}
          render={props => (
            <Post {...props} menuIndex={MenuIndex.HrgaPost}></Post>
          )}
        />

        <Route
          path={`/${PermissionHelper.getUrl(MenuIndex.LocPost)}`}
          render={props => (
            <Post {...props} menuIndex={MenuIndex.LocPost}></Post>
          )}
        />

        <Route
          path={`/${PermissionHelper.getUrl(MenuIndex.ManagementPost)}`}
          render={props => (
            <Post {...props} menuIndex={MenuIndex.ManagementPost}></Post>
          )}
        />

        <Route
          path={`/${PermissionHelper.getUrl(MenuIndex.MarketingPost)}`}
          render={props => (
            <Post {...props} menuIndex={MenuIndex.MarketingPost}></Post>
          )}
        />

        <Route
          path={`/${PermissionHelper.getUrl(MenuIndex.ProductionPost)}`}
          render={props => (
            <Post {...props} menuIndex={MenuIndex.ProductionPost}></Post>
          )}
        />

        <Route
          path={`/${PermissionHelper.getUrl(MenuIndex.StorePost)}`}
          render={props => (
            <Post {...props} menuIndex={MenuIndex.StorePost}></Post>
          )}
        />

        <Route
          path={`/${PermissionHelper.getUrl(MenuIndex.SupportingPost)}`}
          render={props => (
            <Post {...props} menuIndex={MenuIndex.SupportingPost}></Post>
          )}
        />

        <Route
          path={`/${PermissionHelper.getUrl(MenuIndex.Album)}`}
          render={props => (
            <Album {...props} menuIndex={MenuIndex.Album}></Album>
          )}
        />

        <Route
          path={`/${PermissionHelper.getUrl(MenuIndex.User)}`}
          render={props => <User {...props} menuIndex={MenuIndex.User}></User>}
        />
      </div>
    </BrowserRouter>
  </ThemeContextProvider>
);

export default App;
